<template>
  <div class="container">
    <div class="contacts">
      <div class="description">
        <div class="text-block">
          <h1>Architektė - Dizainerė Monika Bartkutė - Blažė</h1>
          <div><b>Telefonas: </b> <span>+37063849592</span></div>
          <div><b>E-paštas: </b> <span>monika@monaarchus.com</span></div>
          <div>
            <b>Instagram: </b>
            <a href="https://www.instagram.com/mona_archus/" target="blank"
              >mona_archus</a
            >
          </div>
          <div>
            <b>Behance: </b>
            <a href="https://www.behance.net/monaarchus" target="blank"
              >/monaarchus</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "MonaArchus - Kontaktai",
      meta: [
        {
          name: "description",
          content:
            "Susisiekime visais interjero projektavimo ir interjero tekstilės kūrimo klausimais bei konsultacijoms. ",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.monaarchus.com/contacts",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/style/pages/contacts";
</style>
